/**
 * Gift Wrap — standalone logic for the cart page.
 * (The cart drawer version runs inside cart-drawer.js)
 */
(function () {
  function toggleNoteWrappers(checked) {
    document
      .querySelectorAll("[data-gift-wrap-note-wrapper]")
      .forEach((wrapper) => {
        if (checked) {
          wrapper.classList.remove("is-hidden");
        } else {
          wrapper.classList.add("is-hidden");
        }
      });
  }

  function toggleOrderNoteSection(giftWrapChecked) {
    document
      .querySelectorAll("[data-order-note-section]")
      .forEach((section) => {
        section.style.display = giftWrapChecked ? "none" : "";
      });
  }

  async function updateCartAttribute(key, value) {
    try {
      const attributes = {};
      attributes[key] = value;
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes }),
      });
    } catch (error) {
      console.error("Error updating cart attribute:", error);
    }
  }

  async function updateCartNote(note) {
    try {
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note }),
      });
    } catch (error) {
      console.error("Error updating cart note:", error);
    }
  }

  async function buildAndSaveCartNote() {
    const isGiftWrap =
      document.querySelector("[data-gift-wrap-checkbox]")?.checked || false;
    const giftMessage = (
      document.querySelector("[data-gift-wrap-note]")?.value || ""
    ).trim();
    const orderNote = (
      document.querySelector("[data-cart-note]")?.value || ""
    ).trim();

    const noteParts = [];

    if (isGiftWrap) {
      let giftSection = "🎁 Gift Wrapping";
      if (giftMessage) {
        giftSection += " | Gift Message: " + giftMessage;
      }
      noteParts.push(giftSection);
    }

    if (orderNote) {
      noteParts.push(orderNote);
    }

    await updateCartNote(noteParts.join("\n---\n"));
  }

  async function updateLineItemProperty(lineKey, propertyKey, propertyValue) {
    try {
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await cartResponse.json();
      const item = cart.items.find((i) => i.key === lineKey);
      if (!item) return;
      const properties = { ...item.properties };
      properties[propertyKey] = propertyValue;
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: lineKey,
          quantity: item.quantity,
          properties: properties,
        }),
      });
    } catch (error) {
      console.error("Error updating line item property:", error);
    }
  }

  function init() {
    // Initial state sync
    const initialCheckbox = document.querySelector("[data-gift-wrap-checkbox]");
    if (initialCheckbox) {
      toggleNoteWrappers(initialCheckbox.checked);
      toggleOrderNoteSection(initialCheckbox.checked);
    }

    // Gift wrap checkbox
    document.addEventListener("change", async (e) => {
      if (e.target.matches("[data-gift-wrap-checkbox]")) {
        const checked = e.target.checked;

        document.querySelectorAll("[data-gift-wrap-checkbox]").forEach((cb) => {
          cb.checked = checked;
        });

        toggleNoteWrappers(checked);
        toggleOrderNoteSection(checked);

        await updateCartAttribute("Gift wrap", checked ? "Yes" : "");

        if (checked) {
          await buildAndSaveCartNote();
        } else {
          await updateCartAttribute("Gift message", "");
          document
            .querySelectorAll("[data-gift-wrap-note]")
            .forEach((textarea) => {
              textarea.value = "";
            });
          await buildAndSaveCartNote();
        }
      }

      if (e.target.matches("[data-line-gift-wrap]")) {
        const item = e.target.closest("[data-cart-item]");
        const lineKey = item?.dataset.lineKey;
        if (lineKey) {
          const checked = e.target.checked;
          await updateLineItemProperty(
            lineKey,
            "_gift_wrap",
            checked ? "Yes" : "",
          );
        }
      }
    });

    // Gift wrap note debounced save
    let giftNoteTimeout;
    document.addEventListener("input", (e) => {
      if (e.target.matches("[data-gift-wrap-note]")) {
        const value = e.target.value;
        document
          .querySelectorAll("[data-gift-wrap-note]")
          .forEach((textarea) => {
            if (textarea !== e.target) textarea.value = value;
          });

        clearTimeout(giftNoteTimeout);
        giftNoteTimeout = setTimeout(async () => {
          await updateCartAttribute("Gift message", value);
          await buildAndSaveCartNote();
        }, 600);
      }
    });

    // Before form submit, save gift wrap note via AJAX and sync textarea
    document.addEventListener("submit", async (e) => {
      const form = e.target;
      if (form.id === "cart" || form.id === "cart-drawer-form") {
        const isGiftWrap =
          document.querySelector("[data-gift-wrap-checkbox]")?.checked || false;
        if (isGiftWrap) {
          e.preventDefault();
          const giftMessage = (
            document.querySelector("[data-gift-wrap-note]")?.value || ""
          ).trim();
          const orderNote = (
            document.querySelector("[data-cart-note]")?.value || ""
          ).trim();
          let fullNote = "🎁 Gift Wrapping";
          if (giftMessage) {
            fullNote += " | Gift Message: " + giftMessage;
          }
          if (orderNote) {
            fullNote += "\n---\n" + orderNote;
          }
          // Save note server-side via AJAX
          await updateCartNote(fullNote);
          // Update all note textareas in DOM
          document
            .querySelectorAll("#cart-note, [name='note']")
            .forEach((el) => {
              el.value = fullNote;
            });
          // Add checkout param so Shopify redirects to checkout
          if (!form.querySelector("input[name='checkout']")) {
            const checkoutInput = document.createElement("input");
            checkoutInput.type = "hidden";
            checkoutInput.name = "checkout";
            checkoutInput.value = "";
            form.appendChild(checkoutInput);
          }
          // Re-submit the form
          form.submit();
        }
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
